var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.componentType && _vm.componentType.view)?_c(_vm.componentType.view,_vm._b({ref:"component",tag:"component",on:{"setParams":_vm.setParams}},'component',_vm.componentProps,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }